import { Link, Href } from 'expo-router';
import { Box } from '../ui/box';
import { Text } from '../ui/text';

type ProjectItemProps = {
  title: string;
  description: string;
  tag?: string;
  href: Href;
  newPage?: boolean;
};

export const ProjectItem: React.FC<ProjectItemProps> = ({
  title,
  description,
  tag,
  href,
  newPage = true,
}) => (
  <Link href={href} {...(newPage && { target: '_blank' })}>
    <Box className="flex flex-col py-4 hover:bg-surface-secondary/50 rounded-md -mx-3 px-3">
      <Box className="flex flex-row justify-between items-baseline">
        <Text variant="body" weight="medium" className="text-text-primary">
          {title}
        </Text>
        {tag && (
          <Text variant="caption" className="font-mono text-text-tertiary">
            {tag}
          </Text>
        )}
      </Box>
      <Text variant="body-sm" className="text-text-tertiary mt-1">
        {description}
      </Text>
    </Box>
  </Link>
);
